// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueClipboard from 'vue-clipboard2'
import ViewUI from 'view-design';
// import style
import 'view-design/dist/styles/iview.css';
// import 'iview/dist/styles/iview.css'
import "./assets/stylesheets/app.scss"
// import "./assets/stylesheets/iview_style_reset.scss"
import store from './store'
import Vue2Filters from 'vue2-filters'

Vue.use(Vue2Filters)
// Vue.use(ViewUI)
import moment from 'moment'
window.moment = moment

Vue.config.productionTip = false
Vue.prototype.Copyright = 'Copyright ® 深圳市领存技术有限公司 | 粤ICP备17069059号'


Vue.use(VueClipboard)

Vue.prototype.download_file = function(url, filename) {
    // let a = document.createElement('a')
    let a = document.getElementById('download')
    a.href = url
    a.download = filename
    a.target = "_blank"
    a.click()
}

switch(process.env.NODE_ENV) {
  case 'production':
    Vue.prototype.sltpUrl = 'https://nandflashtest.storlead.com'
    Vue.prototype.mainUrl = 'https://old.storlead.com'
    break
  case 'development':
    Vue.prototype.sltpUrl = 'http://localhost:8200'
    Vue.prototype.mainUrl = 'http://localhost:8200'
    break
  case 'test':
    // Vue.prototype.sltpUrl = 'https://test.storlead.com/sltp'
    Vue.prototype.sltpUrl = 'http://sltptest.storlead.com'
    Vue.prototype.mainUrl = 'https://test1.storlead.com'
    break
}
import VueAwesomeSwiper from 'vue-awesome-swiper'
// // require styles
import 'swiper/dist/css/swiper.css'
Vue.use(VueAwesomeSwiper, /* { default global options } */)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  store
})
